/**
 * 报表模块翻译 - 中文
 * 包含：合同到期预警、铺位台账、出租率分析、招商进度、租金月报、收缴率预警
 */
export default {
  report: {
    // ==================== 合同到期预警 ====================
    contractExpiry: {
      title: '合同到期预警',
      // 预警卡片
      within30Days: '30天内到期',
      within90Days: '90天内到期',
      within180Days: '180天内到期',
      within1Year: '1年内到期',
      // 筛选
      expiryRange: '到期范围',
      building: '楼栋',
      businessType: '业态',
      days30: '30天内',
      days90: '90天内',
      days180: '180天内',
      days365: '1年内',
      // 业态选项
      bizRetail: '零售',
      bizFood: '餐饮',
      bizEntertainment: '娱乐',
      bizService: '服务',
      // 表格列
      contractNo: '合同编号',
      merchantName: '商户',
      brandName: '品牌',
      shopName: '铺位',
      floorName: '楼层',
      leaseArea: '租赁面积(㎡)',
      monthlyRent: '月租金(元)',
      contractStart: '合同开始',
      contractEnd: '合同到期',
      remainingDays: '剩余天数',
      contractStatus: '合同状态',
      dayUnit: '天',
    },
    // ==================== 收缴率与欠租预警 ====================
    collection: {
      totalReceivable: '总应收',
      totalReceived: '已收',
      overdueAmount: '逾期金额',
      overdueBillCount: '逾期账单数',
      avgOverdueDays: '平均逾期天数',
      overdueDaysDistribution: '逾期天数分布',
      overdueAmountRatio: '逾期金额占比',
      normalAmount: '正常金额',
      billCount: '账单数',
      unitBill: '笔',
      days1to30: '1-30天',
      days31to60: '31-60天',
      days61to90: '61-90天',
      daysOver90: '90天以上',
      descTitle: '说明',
      desc1: '逾期金额为已过账单到期日但尚未收到付款的金额总计，数据每日自动更新。',
      desc2: '逾期天数从账单到期日次日开始计算，平均逾期天数为所有逾期账单的加权平均值。',
      desc3: '建议重点关注逾期90天以上的商户，及时启动催收或法律程序。',
    },

    // ==================== 租金收入月报 ====================
    revenue: {
      // KPI 卡片
      receivableTotal: '应收总额',
      receivedAmount: '已收金额',
      arrearsAmount: '欠收金额',
      collectionRate: '收缴率',
      // 图表标题
      trendTitle: '月度收入趋势（近12个月）',
      compositionTitle: '费用项目构成',
      floorCompareTitle: '各楼层收入对比',
      // 图例
      receivable: '应收',
      received: '实收',
      // 饼图类目
      fixedRent: '固定租金',
      propertyFee: '物业费',
      promotionFund: '推广基金',
      otherFee: '其他',
      // 单位
      tenThousand: '万',
    },

    // ==================== 出租率分析 ====================
    leaseRate: {
      title: '出租率分析',
      totalLeasableArea: '可租总面积',
      leasedArea: '已租面积',
      vacantArea: '空置面积',
      overallLeaseRate: '整体出租率',
      floorLeaseRate: '各楼层出租率',
      floorLeaseRateChart: '各楼层出租率',
      bizLeaseRate: '各业态出租率',
      businessTypeLeaseRateChart: '各业态出租率',
      detailTable: '明细数据',
      targetLine: '目标线',
      footerTotal: '合计',
      colName: '名称',
      totalShops: '铺位总数',
      leasedShops: '已租铺位',
      colTotalShops: '铺位总数',
      colRentedShops: '已租铺位',
      colTotalArea: '总面积(㎡)',
      colLeasedArea: '已租面积(㎡)',
      colRentedArea: '已租面积(㎡)',
      colVacantArea: '空置面积(㎡)',
      colLeaseRate: '出租率(%)',
    },

    // ==================== 招商进度总览 ====================
    leasing: {
      title: '招商进度总览',
      totalShops: '铺位总数',
      signRate: '签约率',
      openRate: '开业率',
      activeIntentions: '活跃意向数',
      progressDistribution: '招商进度分布',
      floorSignRate: '各楼层签约率',
      bizSignStats: '各业态签约情况',
      signed: '已签约',
      unsigned: '未签约',
      statusEntered: '已入驻',
      statusRenovating: '装修中',
      statusSigned: '已签约',
      statusActive: '有意向',
      statusNegotiating: '洽谈中',
      statusVacant: '空置',
      statusReserved: '预留',
      statusMaintenance: '维修',
    },

    // ==================== 铺位台账总览 ====================
    shopLedger: {
      title: '铺位台账总览',
      // 统计卡片
      totalShops: '铺位总数',
      totalGLA: '可租总面积(GLA)',
      rentedArea: '已租面积',
      vacantArea: '空置面积',
      leaseRate: '出租率',
      avgRentPrice: '平均租金单价',
      // 筛选条件
      building: '楼栋',
      floor: '楼层',
      businessType: '业态',
      shopStatus: '资产状态',
      keyword: '关键词',
      keywordPlaceholder: '铺位编码/名称/商户/品牌',
      // 表格列
      colBuilding: '楼栋',
      colFloor: '楼层',
      colShopCode: '资产编码',
      colShopName: '资产名称',
      colArea: '面积',
      colRentableArea: '可租面积',
      colBusinessType: '规划业态',
      colShopStatus: '资产状态',
      colMerchant: '商户',
      colBrand: '品牌',
      colContractNo: '合同编号',
      colContractPeriod: '合同起止',
      colMonthlyRent: '月租金',
      colLeasingStatus: '招商状态',
      // 铺位状态标签
      statusRented: '已租',
      statusAvailable: '可租',
      statusReserved: '预留',
      statusMaintenance: '维修',
    },

    // ==================== 意向转化漏斗 ====================
    conversionFunnel: {
      title: '意向转化漏斗',
      // 漏斗指标
      negotiationCount: '洽谈记录数',
      intentionTotal: '意向总数',
      activeIntentionCount: '有效意向',
      convertedCount: '已转化签约',
      activeContractCount: '合同生效',
      overallConversionRate: '整体转化率',
      intentionLossRate: '意向流失率',
      depositRate: '意向金收取率',
      // 漏斗阶段
      stageNegotiation: '洽谈记录',
      stageIntentionTotal: '意向总数',
      stageActiveIntention: '有效意向',
      stageConverted: '已转化签约',
      stageActiveContract: '合同生效',
      // 转化率
      conversionRate: '转化率',
      funnelChart: '意向转化漏斗图',
      conversionChart: '各阶段转化率',
      // 说明
      desc1: '整体转化率 = 已签约合同数 / 意向总数 × 100%',
      desc2: '意向流失率 = (已取消 + 已过期) / 意向总数 × 100%',
    },

    // ==================== 品牌与业态结构 ====================
    brandStructure: {
      title: '品牌与业态结构',
      // KPI
      totalContracts: '合同总数',
      totalArea: '总面积',
      totalShops: '铺位总数',
      // 图表
      bizAreaDistribution: '业态面积分布',
      brandGradeDistribution: '品牌等级分布',
      brandTypeDistribution: '品牌类型分布',
      // 等级
      gradeInternational: '国际品牌',
      gradeNational: '全国品牌',
      gradeRegular: '普通品牌',
      // 类型
      typeAnchor: '主力店',
      typeSubAnchor: '次主力',
      typeStandard: '标准铺',
      // 表格列
      colBusinessType: '业态',
      colContractCount: '合同数',
      colArea: '面积(㎡)',
      colAreaRatio: '面积占比',
      colBrandCount: '品牌数',
    },

    // ==================== 业态规划及落位分析 ====================
    planningAnalysis: {
      title: '业态规划及落位分析',
      // KPI
      totalShops: '总铺位数',
      completionRate: '规划完成率',
      coverageRate: '业态覆盖率',
      primaryPlacementRate: '首选品牌占比',
      avgDeviation: '平均规划偏差',
      placedCount: '已落位品牌数',
      // 筛选
      year: '规划年度',
      allYears: '全部年度',
      // 图表
      comparisonChart: '业态规划vs实际对比',
      stackedChart: '楼层业态面积分布',
      placementPie: '品牌落位状态分布',
      brandLevelChart: '品牌等级分布',
      planned: '规划',
      actual: '实际',
      // 表格列
      colFloor: '楼层',
      colBusinessType: '业态类型',
      colTargetCount: '规划铺位数',
      colActualCount: '实际铺位数',
      colCompletionRate: '完成率',
      colTargetArea: '规划面积(㎡)',
      colActualArea: '实际面积(㎡)',
      colAreaAchieveRate: '面积达成率',
      colDeviation: '偏差值(%)',
      colStatus: '状态',
      // 状态标签
      statusOnTrack: '达标',
      statusOffTrack: '偏差',
      statusCritical: '异常',
      // 落位状态
      placedFormal: '已正式落位',
      placedInformal: '非正式落位',
      converted: '已转意向',
      cancelled: '已取消',
      // 品牌等级
      levelInternational: '国际品牌',
      levelNational: '全国品牌',
      levelOrdinary: '普通品牌',
    },

    // ==================== 销售额统计 ====================
    salesStatistics: {
      title: '销售额统计',
      // KPI
      monthlySales: '当月销售额',
      yearlySales: '当年累计',
      momGrowth: '环比增长',
      yoyGrowth: '同比变化',
      reportedShopCount: '上报铺位数',
      // 图表
      monthlyTrend: '月度销售趋势（近12个月）',
      bizSalesDistribution: '各业态销售额占比',
      topShopsTitle: '销售额TOP10铺位',
      topBrandsTitle: '销售额TOP10品牌',
      // 表格列
      colRank: '排名',
      colShopName: '铺位',
      colMerchant: '商户',
      colBrand: '品牌',
      colFloor: '楼层',
      colSalesAmount: '销售额(元)',
      colGrowth: '环比',
    },

    // ==================== 开业筹备进度 ====================
    openingProgress: {
      title: '开业筹备进度',
      // KPI
      totalCount: '总筹备数',
      renovatingCount: '装修中',
      pendingAcceptanceCount: '待验收',
      pendingOpeningCount: '待开业',
      openedCount: '已开业',
      openingRate: '开业率',
      // 图表
      statusDistribution: '筹备状态分布',
      // 表格列
      colShopName: '铺位',
      colMerchant: '商户',
      colBrand: '品牌',
      colRenovationType: '装修类型',
      colPlannedStart: '计划开工',
      colPlannedEnd: '计划竣工',
      colActualStart: '实际开工',
      colActualEnd: '实际竣工',
      colOpeningDate: '计划开业',
      colDeviation: '工期偏差(天)',
      colStatus: '状态',
      // 状态
      statusRenovating: '装修中',
      statusPendingAcceptance: '待验收',
      statusPendingOpening: '待开业',
      statusOpened: '已开业',
      statusCompleted: '已完成',
    },

    // ==================== 物业工单报表 ====================
    workOrder: {
      title: '物业工单统计',
      // KPI
      totalCount: '工单总量',
      pendingCount: '待处理',
      inProgressCount: '处理中',
      completedCount: '已完成',
      avgHandlingHours: '平均处理时长(小时)',
      onTimeRate: '按时完成率',
      responseRate: '响应率',
      // 分布
      distributionTitle: '工单分布分析',
      byPriority: '按优先级',
      byOrderType: '按工单类型',
      bySource: '按来源',
      byBuilding: '按楼栋',
      byStatus: '按状态',
      // 效率
      efficiencyTitle: '工单效率分析',
      avgResponseMinutes: '平均响应时长(分钟)',
      avgHandlingHoursShort: '平均处理时长',
      responseRateShort: '响应率',
      completionRate: '完成率',
      overdueCount: '超时工单数',
      overdueRate: '超时率',
      dailyTrend: '每日工单趋势',
      colCreated: '创建工单',
      colCompleted: '完成工单',
      // 工单明细
      orderNo: '工单编号',
      orderType: '工单类型',
      priority: '优先级',
      colStatus: '状态',
      colBuilding: '楼栋',
      source: '来源',
      shopName: '铺位',
      creatorName: '创建人',
      assignedName: '处理人',
      createTime: '创建时间',
      completedTime: '完成时间',
      handlingHours: '处理时长(小时)',
      // 状态
      statusPending: '待派单',
      statusAssigned: '已派单',
      statusInProgress: '处理中',
      statusCompleted: '已完成',
      statusClosed: '已关闭',
      statusCancelled: '已取消',
      // 优先级
      priorityUrgent: '紧急',
      priorityHigh: '高',
      priorityNormal: '普通',
      priorityLow: '低',
      // 来源
      sourceInternal: '内部',
      sourceMerchant: '商户',
      sourcePublic: '公共',
    },

    // ==================== 广告位经营报表 ====================
    advertising: {
      title: '广告位经营概览',
      // KPI
      totalCount: '广告位总数',
      availableCount: '可用数',
      rentedCount: '已租数',
      maintenanceCount: '维护中',
      reservedCount: '预留数',
      totalArea: '总面积(m²)',
      totalMonthlyRent: '总月租(元)',
      avgMonthlyRentPerArea: '平均月租(元/m²)',
      availableRate: '可用率',
      rentedRate: '已租率',
      // 分析
      analysisTitle: '广告位经营分析',
      byType: '按类型',
      byDisplayType: '按展示形式',
      byBuilding: '按楼栋',
      byFloor: '按楼层',
      topByRent: '月租TOP榜',
      // 状态
      statusAvailable: '可租',
      statusRented: '已租',
      statusMaintenance: '维护中',
      statusReserved: '预留',
      statusDistribution: '状态分布',
      // 类型
      typeIndoor: '室内',
      typeOutdoor: '室外',
      typeElevator: '电梯',
      typeCommonArea: '公共区域',
      // 展示形式
      displayStatic: '静态',
      displayDigital: '数字',
      displayLed: 'LED屏',
      // 表格列
      colName: '名称',
      colArea: '面积(m²)',
      colMonthlyRent: '月租(元)',
      colRatio: '占比',
      colBuilding: '楼栋',
      colFloor: '楼层',
      colRank: '排名',
    },

    // ==================== KPI考核报表 ====================
    kpi: {
      title: 'KPI考核报表',
      personalTitle: '个人KPI',
      rankingTitle: '团队排名',
      overviewTitle: '管理层总览',
      periodType: '考核周期',
      monthly: '月度',
      quarterly: '季度',
      year: '年份',
      month: '月份',
      quarter: '季度',
      selectUser: '选择人员',
      allUsers: '全部',
      targetValue: '目标值',
      actualValue: '实际值',
      achievementRate: '达成率',
      unit: '单位',
      status: '状态',
      overallAchievement: '综合达成率',
      rank: '排名',
      userName: '姓名',
      coreIndicator: '核心指标',
      export: '导出报表',
      noData: '暂无数据',
      roleTabs: {
        overview: '总览',
        recruitment: '招商',
        operation: '营运',
        finance: '财务',
        property: '物业'
      },
      statusGreen: '达标',
      statusWarning: '预警',
      statusRed: '未达标',
      overviewCard: {
        teamSize: '团队人数',
        passed: '达标人数',
        bestPerformer: '最佳员工',
        bestRate: '最高达成率'
      }
    },

  // ==================== P0 新增报表 ====================
  receivableDetail: {
    title: '应收实收明细',
    yearMonth: '月份',
    contractNo: '合同编号',
    manualContractNo: '手工合同号',
    merchantName: '商户',
    brandName: '品牌',
    assetName: '资产',
    feeItemName: '费用项',
    calcType: '计费方式',
    receivableAmount: '应收金额',
    paidAmount: '已收金额',
    diffAmount: '差额',
    overdueDays: '逾期天数',
    feeStatus: '状态',
    dueDate: '应缴日期',
    statusPaid: '已收',
    statusPending: '待收',
    statusOverdue: '逾期',
    contractStatus: '合同状态',
    feeStatusFilter: '收款状态',
    merchantBrandFilter: '商户/品牌',
    merchantBrandPlaceholder: '商户或品牌名称',
    contractFilter: '合同',
    contractPlaceholder: '合同编号',
    totalReceivable: '合计应收',
    totalPaid: '合计已收',
    totalDiff: '合计差额'
  },
  contractLedger: {
    title: '合同台账',
    contractNo: '合同编号',
    manualContractNo: '手工合同号',
    merchantName: '商户',
    brandName: '品牌',
    assetName: '资产',
    assetTypeName: '资产类型',
    floorName: '楼层',
    buildingName: '楼栋',
    businessTypeName: '业态',
    leaseArea: '面积(㎡)',
    standardRent: '月租金',
    contractStart: '开始日期',
    contractEnd: '结束日期',
    contractStatusName: '状态',
    signCompanyName: '签约公司',
    keyword: '关键词',
    assetType: '资产类型',
    contractStatus: '合同状态'
  },
  vacantAssetDetail: {
    title: '空置资产明细表',
    assetTypeName: '资产类型',
    assetCode: '资产编号',
    assetName: '资产名称',
    floorName: '楼层',
    buildingName: '楼栋',
    area: '面积(㎡)',
    statusName: '状态',
    vacantDays: '空置天数',
    businessTypeName: '规划业态'
  },
  agingAnalysis: {
    title: '账龄分析表',
    contractNo: '合同编号',
    merchantName: '商户',
    totalPlan: '应付总额',
    totalPaid: '已付总额',
    totalOverdue: '欠款合计',
    notOverdue: '未逾期',
    within30: '1-30天',
    within31to60: '31-60天',
    within61to90: '61-90天',
    over90: '90天以上'
  },
  paymentReconciliation: {
    title: '收款对账表',
    yearMonth: '月份',
    contractNo: '合同编号',
    merchantName: '商户',
    feeItemName: '费用项',
    totalReceivable: '应收合计',
    totalReceived: '实收合计',
    diffAmount: '差异额',
    collectionRate: '收缴率(%)',
    sumReceivable: '合计应收',
    sumReceived: '合计已收',
    sumDiff: '合计差额',
    total: '合计'
  },
  renewalWarning: {
    title: '续签预警表',
    contractNo: '合同编号',
    merchantName: '商户',
    brandName: '品牌',
    assetName: '资产',
    assetTypeName: '资产类型',
    leaseArea: '面积(㎡)',
    monthlyRent: '月租金',
    contractStart: '开始日期',
    contractEnd: '到期日期',
    remainingDays: '剩余天数',
    warningLevel: '预警级别',
    levelUrgent: '紧急(30天内)',
    levelWarning: '预警(60天内)',
    levelCaution: '提醒(90天内)',
    levelNormal: '正常'
  },
  negotiationDetail: {
    title: '洽谈跟进明细表',
    negotiationDate: '洽谈日期',
    merchantName: '商户',
    brandName: '品牌',
    assetName: '目标资产',
    negotiationTypeName: '洽谈方式',
    negotiator: '洽谈人',
    content: '洽谈内容',
    resultName: '结果',
    probabilityName: '成交概率',
    statusName: '状态',
    followUpDate: '跟进日期',
    nextSteps: '下一步',
    statusFilter: '状态',
    resultFilter: '结果',
    keyword: '关键词'
  },
  salesSummary: {
    title: '销售上报汇总表',
    yearMonth: '月份',
    merchantName: '商户',
    brandName: '品牌',
    shopName: '铺位',
    salesAmount: '销售额',
    totalQuantity: '笔数',
    efficiency: '坪效',
    prevYearSales: '去年同期',
    yoyRate: '同比(%)'
  },
  workOrderDetail: {
    title: '工单处理明细表',
    orderNo: '工单编号',
    title_col: '标题',
    orderTypeName: '类型',
    priorityName: '优先级',
    statusName: '状态',
    sourceName: '来源',
    buildingName: '楼栋',
    floorName: '楼层',
    shopName: '位置',
    creatorName: '创建人',
    assignedName: '处理人',
    createTime: '创建时间',
    acceptedTime: '接单时间',
    completedTime: '完成时间',
    handlingHours: '处理时长(h)',
    description: '描述',
    orderType: '工单类型',
    status: '工单状态'
  },
  depositLedger: {
    title: '保证金台账',
    depositNo: '保证金编号',
    contractNo: '合同编号',
    merchantName: '商户',
    depositTypeName: '保证金类型',
    feeItemName: '费用项',
    totalAmount: '应收金额',
    deductedAmount: '已扣金额',
    refundedAmount: '已退金额',
    balance: '余额',
    statusName: '状态',
    receiveDate: '收款日期',
    receiveMethodName: '收款方式',
    receiveBy: '收款人',
    keyword: '关键词',
    depositType: '类型',
    status: '状态'
  },
  merchantLedger: {
    title: '财务往来账',
    keyword: '关键词',
    accountType: '账户类型',
    bizType: '业务类型',
    businessMode: '经营模式',
    partnerRole: '对象角色',
    bizDate: '业务日期',
    entryNo: '分录号',
    merchantName: '往来对象',
    contractNo: '合同编号',
    feeItemName: '费用名目',
    summary: '摘要',
    bizNo: '业务单号',
    refDoc: '来源单',
    debit: '借方',
    credit: '贷方',
    balance: '余额',
    remark: '备注'
  },
  intentionConversion: {
    title: '意向转化明细表',
    intentionNo: '意向编号',
    merchantName: '商户',
    brandName: '品牌',
    assetName: '目标资产',
    assetTypeName: '资产类型',
    intentionDate: '意向日期',
    proposedRent: '意向租金',
    proposedArea: '意向面积',
    depositAmount: '保证金',
    intentionStatusName: '意向状态',
    conversionStatus: '转化状态',
    contractNo: '合同编号',
    expiryDate: '有效期至',
    creator: '创建人',
    intentionStatus: '意向状态',
    keyword: '关键词'
  },
  rentSalesRatio: {
    title: '租售比明细表',
    yearMonth: '月份',
    merchantName: '商户',
    brandName: '品牌',
    shopName: '铺位',
    salesAmount: '销售额',
    rentAmount: '租金',
    rentSalesRatio: '租售比(%)',
    warningLevel: '预警'
  },
  energyAllocation: {
    title: '能耗公摊分摊表',
    yearMonth: '月份',
    meterTypeName: '能耗类型',
    meterName: '仪表名称',
    meterCode: '仪表编号',
    merchantName: '商户',
    shopName: '铺位',
    previousReading: '上期读数',
    currentReading: '本期读数',
    usageAmount: '用量',
    unitPrice: '单价',
    feeAmount: '费用',
    unit: '单位',
    readingDate: '抄表日期',
    reader: '抄表人',
    meterType: '能耗类型'
  },
  overdueDetail: {
    title: '逾期账款明细表',
    contractNo: '合同编号',
    merchantName: '商户',
    brandName: '品牌',
    assetName: '资产',
    yearMonth: '账单月份',
    planAmount: '应付金额',
    paidAmount: '已付金额',
    overdueAmount: '逾期金额',
    overdueDays: '逾期天数',
    overdueRange: '逾期区间',
    dueDate: '应缴日期',
    planStatusName: '状态',
    overdueRangeFilter: '逾期区间'
  }
  }
}
